import { ExportAllListActions } from '../ExportAllButton';
import {
  EditGuesser,
  FieldGuesser,
  InputGuesser,
  ListGuesser,
} from '@api-platform/admin';
import {
  DateField,
  ReferenceField,
  TextField,
  TextInput,
  NumberInput, DateTimeInput
} from 'react-admin';
import React from 'react';
import { Grid } from '@mui/material';
import { getSelectedCompanyFilter } from '../../helper/filter';

export const ReviewList = (props) => {
  const filters = [
    <TextInput label="Name" source="name" />,
    <TextInput label="Email" source="email" />,
    <TextInput label="City" source="courseCity.city.name" />,
    <TextInput label="Course" source="course.code" />,
  ];

  const companyFilter = getSelectedCompanyFilter();

  return (
    <ListGuesser
      actions={<ExportAllListActions />}
      {...props}
      filters={filters}
      filter={companyFilter}
    >
      <FieldGuesser source={'name'} />
      <FieldGuesser source={'email'} />
      <ReferenceField
        label="Course"
        source="course"
        sortBy="course.code"
        reference="courses"
      >
        <TextField source="code" />
      </ReferenceField>
      <ReferenceField
        label="CourseCity"
        source="courseCity"
        sortBy={'courseCity.city.name'}
        reference="course_cities"
      >
        <TextField source="cityView" />
      </ReferenceField>
      <ReferenceField
        label="CourseCityDate"
        source="courseCityDate"
        sortBy={'courseCityDate.startDate'}
        reference="course_city_dates"
      >
        <TextField source="dateView" />
      </ReferenceField>
      <ReferenceField
        label="Company"
        source="company"
        sortBy="company.name"
        reference="companies"
      >
        <TextField source="name" />
      </ReferenceField>
      <FieldGuesser source={'rating'} />
      <FieldGuesser source={'confirmed'} />
      <ReferenceField label="CreatedBy" source="createdBy" reference="users">
        <TextField source="email" />
      </ReferenceField>
      <DateField source={'updatedAt'} locales={'de'} showTime />
      <DateField source={'createdAt'} locales={'de'} showTime />
    </ListGuesser>
  );
};

export const ReviewEdit = (props) => (
  <EditGuesser {...props}>
    <Grid container spacing={4} sx={{ p: 2 }}>
      <Grid item xs={6}>
        <InputGuesser fullWidth source={'name'} />
        <InputGuesser fullWidth source={'email'} />
        <InputGuesser required fullWidth source={'useful'} min={0} />
        <InputGuesser required fullWidth source={'useless'} min={0} />
        <NumberInput required fullWidth source={'rating'} min={1} max={5} />
        <InputGuesser fullWidth source={'confirmed'} />
      </Grid>
      <Grid item xs={6}>
        <TextInput fullWidth multiline rows={3} source={'title'} />
        <TextInput fullWidth multiline rows={10} source={'comment'} />
        <TextInput fullWidth multiline rows={10} source={'adminComment'} />
          <DateTimeInput
              source="modifiedCreatedAt"
              label="Different created at"
          />
      </Grid>
    </Grid>
  </EditGuesser>
);
